import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-008a53b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box-box"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "tools-grid"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "tool-icon"
};
import { ref, computed } from 'vue';
import { Link, Monitor, Grid, PictureFilled } from '@element-plus/icons-vue';
export default {
  __name: 'imgNav',
  setup(__props) {
    const navigateTo = url => {
      window.location.href = url;
    };

    // 定义工具列表
    const tools = [{
      title: "批量图片压缩处理",
      description: "批量处理多张图片，支持图片文件后缀转换、压缩等操作",
      url: "/batch.html",
      icon: PictureFilled
    }, {
      title: "单张图片压缩处理",
      description: "处理单张图片，支持长图分段切割压缩，图片添加水印，图片旋转，图片放大缩小",
      url: "/single.html",
      icon: PictureFilled
    }, {
      title: "URL获取图像",
      description: "提取网页图片或处理在线图片链接，轻松获取各种网络资源",
      url: "/url.html",
      icon: Link
    }, {
      title: "网页截图",
      description: "一键将网页转换为长图或PDF，便于保存和分享",
      url: "/pdfchange.html",
      icon: Monitor
    }, {
      title: "二维码生成",
      description: "创建自定义二维码，可添加LOGO和个性化设计",
      url: "/towcode.html",
      icon: Grid
    }];

    // 定义搜索查询和过滤后的工具列表
    const searchQuery = ref('');
    const filteredTools = computed(() => {
      if (searchQuery.value === '') {
        return tools;
      }
      return tools.filter(tool => {
        const titleMatch = tool.title.toLowerCase().includes(searchQuery.value.toLowerCase());
        const descriptionMatch = tool.description.toLowerCase().includes(searchQuery.value.toLowerCase());
        return titleMatch || descriptionMatch;
      });
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(PictureFilled))]),
        _: 1
      }), _createTextVNode(" 图片处理工具 ")]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchQuery.value = $event),
        type: "text",
        placeholder: "搜索",
        class: "search-input"
      }, null, 512), [[_vModelText, searchQuery.value]])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTools.value, (tool, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "tool-card",
          onClick: $event => navigateTo(tool.url)
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
          is: tool.icon
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tool.icon)))]),
          _: 2
        }, 1032, ["is"])]), _createElementVNode("h3", null, _toDisplayString(tool.title), 1), _createElementVNode("p", null, _toDisplayString(tool.description), 1)], 8, _hoisted_5);
      }), 128))])]);
    };
  }
};